// extracted by mini-css-extract-plugin
export default {"messageSenderWrapper":"chatMessageSender_messageSenderWrapper__ZOl7o","sendMessage":"chatMessageSender_sendMessage__NUmj6","messageWarning":"chatMessageSender_messageWarning__GMGEX"};